@if (carnetEquipement$ | async; as carnetEquipement) {
  <section class="container-background container-fluid content">
    <div class="row">
      <h2 class="page-title col-12">{{carnetEquipement.equipement.nom}}@if (carnetEquipement.equipement.categorie) {
        <small class="ms-3"
        >{{carnetEquipement.equipement.categorie.nom}}</small>
      }
    </h2>
  </div>
  <div class="m-2 p-4 bg-white rounded">
    <form [formGroup]="form" (ngSubmit)="save()">
      <div class="row">
        @if (form.get('marque'); as control) {
          <div class="mb-3 col-12 col-lg-6">
            <label for="marque">Marque</label>
            <input class="form-control" id="marque" type="text" formControlName="marque" [ngClass]="{'is-invalid': !control.valid}" placeholder="EX-TECH"/>
            <div class="invalid-feedback">{{ control.errors }}</div>
          </div>
        }
        @if (carnetEquipement.equipement.marque) {
          <div class="mb-3 col-12 col-lg-6">
            <label for="reference">La marque du fabriquant</label>
            <div  class="form-control-plaintext">{{carnetEquipement.equipement.marque}}</div>
          </div>
        }
      </div>
      <div class="row">
        @if (form.get('reference'); as control) {
          <div class="mb-3 col-12 col-lg-6">
            <label for="reference">Référence</label>
            <input class="form-control" id="reference" type="text" formControlName="reference" [ngClass]="{'is-invalid': !control.valid}" placeholder="RF-1234"/>
            <div class="invalid-feedback">{{ control.errors }}</div>
          </div>
        }
        @if (carnetEquipement.equipement.reference) {
          <div class="mb-3 col-12 col-lg-6">
            <label for="reference">La référence du fabriquant</label>
            <div  class="form-control-plaintext">{{carnetEquipement.equipement.reference}}</div>
          </div>
        }
      </div>
      <div class="row">
        @if (form.get('urlFabriquant'); as control) {
          <div class="mb-3 col-12 col-lg-6">
            <label for="urlFabriquant">Site internet</label>
            <input class="form-control" id="urlFabriquant" type="text" formControlName="urlFabriquant" [ngClass]="{'is-invalid': !control.valid}" placeholder="https://www.pacific.fr/"/>
            <div class="invalid-feedback">{{ control.errors }}</div>
          </div>
        }
        @if (carnetEquipement.equipement.urlFabriquant) {
          <div class="mb-3 col-12 col-lg-6">
            <label for="reference">Le site internet du fabriquant</label>
            <div  class="form-control-plaintext"><a target="_blank" class="color-saumon" [href]="carnetEquipement.equipement.urlFabriquant">{{carnetEquipement.equipement.urlFabriquant}}</a></div>
          </div>
        }
      </div>
      <div class="row">
        <div class="mb-3 col-12 col-lg-6">
          <label for="notice">{{image.metadata ? 'Photo' : 'La photo du fabriquant'}}</label>
          <app-cover [image]="image.metadata || carnetEquipement.equipement.image && (carnetEquipement.equipement.image.url | backResource)">
            <input #imageInput type="file" id="image" class="d-none" accept="image/x-png,image/gif,image/jpeg" (change)="updateImage($event)"/>
            <div class="d-flex">
              @if (image.metadata) {
                <a class="me-4 cursor-pointer" (click)="deleteImage()"><fa-icon [icon]="faTrash"></fa-icon>&nbsp;<span class="d-none d-sm-inline">Supprimer</span></a>
              }
              <label for="image" class="cursor-pointer"><fa-icon [icon]="faCloudUploadAlt"></fa-icon>&nbsp;<span class="d-none d-sm-inline">Mettre à jour</span></label>
            </div>
          </app-cover>
        </div>
        @if (carnetEquipement.equipement.image && image.metadata) {
          <div class="mb-3 col-12 col-lg-6">
            <label for="reference">La photo du fabriquant</label>
            <app-cover [image]="carnetEquipement.equipement.image.url | backResource"></app-cover>
          </div>
        }
      </div>
      <div class="row">
        <div class="mb-3 col-12 col-lg-6">
          <label for="notice">Notice</label>
          <div class="form-control-plaintext">
            @if (notice.isUpload) {
              <a class="color-saumon" target="_blank" [href]="notice.metadata | backResource">Télécharger</a>
            } @else {
              <input #noticeInput class="form-control" id="notice" type="file" (change)="updateNotice($event)"/>
            }
            @if (notice.isUpload) {
              <button class="ms-3 btn btn-light" (click)="deleteNotice()"><fa-icon [icon]="faTrash"></fa-icon>&nbsp;<span class="d-none d-sm-inline">Supprimer</span></button>
            }
          </div>
        </div>
        @if (carnetEquipement.equipement.notice) {
          <div class="mb-3 col-12 col-lg-6">
            <label for="reference">La notice du fabriquant</label>
            <div class="form-control-plaintext">
              <a target="_blank" class="color-saumon" [href]="carnetEquipement.equipement.notice.url | backResource">Télécharger</a>
            </div>
          </div>
        }
      </div>
      <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-bottom justify-content-center">
        @if (extraRouter.previousUrl) {
          <a class="btn btn-light" [routerLink]="extraRouter.previousUrl">Annuler</a>
          }&nbsp;
          <button type="submit" class="btn btn-blue" [disabled]="loaderService.loading | async">Enregistrer</button>
        </nav>
      </form>
    </div>
  </section>
}
